import { useMemo } from 'react';
import { useSimulationStore } from '@/state/simulationStore';
import { useSessionStore } from '@/state/sessionStore';
import { useConfirmationsView, type ConfirmationsViewBundle } from '@/api/views';
import { buildConfirmationWorklist } from '@/domain/confirmationWorklist';

const EMPTY: Record<string, never> = {};

/**
 * THE Confirmations worklist read: one query (the persona-studio-scoped
 * confirmations view) + one builder, shared by the screen and the LeftRail
 * badge so the badge always equals the screen's count (tv-2na.11.2).
 * assignedStudios stays sessionStore config, not brain data.
 */
export function useConfirmationWorklist(opts?: { enabled?: boolean }) {
  const clockIso = useSimulationStore((s) => s.clockIso);
  const assignedStudios = useSessionStore((s) => s.assignedStudios);
  const { data } = useConfirmationsView(assignedStudios, opts);
  const bundle: ConfirmationsViewBundle | undefined = data;
  const bookings = bundle?.bookings ?? EMPTY;
  const confirmationCalls = bundle?.confirmationCalls ?? EMPTY;
  const worklist = useMemo(
    () => buildConfirmationWorklist({ nowIso: clockIso, bookings, confirmationCalls, studioIds: assignedStudios }),
    [clockIso, bookings, confirmationCalls, assignedStudios],
  );
  return { bundle, worklist, clockIso, assignedStudios };
}
